module.exports = __webpack_public_path__ + "img/Stars.c6e26c6a.png";